import React from "react";

interface DicebearThumbProps {
    seed: string;
    size?: number;
    alt?: string;
    style?: React.CSSProperties;
}

// Module-scope cache (survives across renders)
const dicebearCache: Record<string, string> = {};

const getDicebearUrl = (seed: string): string => {
    if (!dicebearCache[seed]) {
        dicebearCache[seed] = `https://api.dicebear.com/7.x/thumbs/svg?seed=${encodeURIComponent(seed)}`;
    }
    return dicebearCache[seed];
};

const DicebearThumb: React.FC<DicebearThumbProps> = ({ seed, size = 30, alt = "Dicebear Avatar", style }) => {
    const url = getDicebearUrl(seed);
    return <img src={url} width={size} height={size} alt={alt} style={style} loading="lazy" draggable={false} />;
};

export default DicebearThumb;
